import { getDocument, fetchDocuments } from '@/services/documentService';
import { base64ToArrayBuffer, createAndDownloadBlobFile } from '@/services/downloadService';
import { GET_DOCUMENT, FETCH_DOCUMENTS } from './actions.type';

const initialState = {
  documents: [],
};

const documentModule = {
  state: () => initialState,
  getters: {
    documents: (state) => state.documents,
  },
  actions: {
    async [GET_DOCUMENT](_, documentId) {
      const { data } = await getDocument(documentId);

      const arrayBuffer = base64ToArrayBuffer(data.file);

      createAndDownloadBlobFile(arrayBuffer, data.path);
    },

    async [FETCH_DOCUMENTS](context) {
      let { data } = await fetchDocuments();

      data = data.map((v) => ({
        ...v,
        id: v.id ? v.id.toString() : undefined,
      }));

      context.commit(FETCH_DOCUMENTS, data);
    },
  },
  mutations: {
    [FETCH_DOCUMENTS](state, documents) {
      state.documents = documents;
    },
  },
};

export default documentModule;
